export const ideaRoutePaths = {
  ideas: {
    path: 'board/idea',
    fullPath: '/board/idea',
  },
  ideaWrite: {
    path: 'board/idea/write',
    fullPath: '/board/idea/write',
  },
  ideaDetail: {
    path: 'board/idea/:boardId',
    fullPath: (boardId: string) => `/board/idea/${boardId}`,
  },
  feeds: {
    path: 'board/feed',
    fullPath: '/board/feed',
  },
  feedWrite: {
    path: 'board/feed/write',
    fullPath: '/board/feed/write',
  },
  feedDetail: {
    path: 'board/feed/:feedId',
    fullPath: (feedId: string) => `/board/feed/${feedId}`,
  },
};
